module.exports = __webpack_public_path__ + "static/media/history-cold-war.32d7ed84.mp4";